import { Box, Typography } from '@mui/material';
import useIsMobile from './hooks/useIsMobile';
import HorizontalFrame from './HorizontalFrame';
import VerticalFrame from './VerticalFrame';
import './PagePart.css';

interface ContentProps {
    contents: string[];
    type: 'horizontal' | 'vertical';
    isPdf?: boolean;
    isYoutube?: boolean;
}

interface PagePartProps {
    text: string;
    image: string;
    contents: ContentProps[];
    isHighlighted?: boolean;
    hasArrows?: boolean;
}

function PagePart(props: PagePartProps) {
    const isMobile = useIsMobile();

    return (
        <Box
            id={props.text.toLowerCase()}
            sx={{
                position: 'relative',
            }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '50%',
                }}
            >
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginTop: 12,
                    justifyContent: 'center',
                    transform: props.isHighlighted ? 'scale(1.1)' : 'scale(1)',
                    transition: 'all 0.5s',
                }}
            >
                <img
                    src={props.image}
                    alt={props.text}
                    style={{
                        width: isMobile ? 90 : 120,
                        height: isMobile ? 90 : 120,
                        filter: props.isHighlighted ? 'brightness(1.4) drop-shadow(0 0 4px white)' : 'brightness(1)',
                        animation: props.isHighlighted ? 'textGlow 3s infinite' : 'none',
                        margin: 'auto',
                    }}
                />
                <Typography
                    variant="h4"
                    sx={{
                        mt: 1,
                        textAlign: 'center',
                        color: 'white',
                        filter: props.isHighlighted ? 'brightness(1.4) drop-shadow(0 0 4px white)' : 'brightness(1)',
                        animation: props.isHighlighted ? 'textGlow 3s infinite' : 'none',
                    }}
                >
                    {props.text}
                </Typography>
            </Box>
            <Box
                sx={{
                }}
            >
                {props.contents.map((content: ContentProps, index) => (
                    <Box
                        key={index}
                    >
                        {content.type === 'vertical'
                            ? <VerticalFrame
                                frameImage={'/img/content_frame_v.png'}
                                content={content.contents}
                                isPdf={content.isPdf}
                                isMobile={isMobile}
                                isYoutube={content.isYoutube === true}
                            />
                            : <HorizontalFrame
                                frameImage={'/img/content_frame_h.png'}
                                isPdf={content.isPdf}
                                contents={content.contents}
                                isYoutube={content.isYoutube === true}
                            />
                        }
                    </Box>
                ))}
            </Box>
        </Box>
    );
}

export default PagePart;
